<div class="requiredTextbox__badge__container">
  <mat-icon 
    matBadge="{{(requiredTextTotal$| async).toString()}}"
    matBadgeSize="small"
    matBadgeHidden="{{(requiredTextTotal$| async) === 0}}"
    data-testid="textbox-text"
    class="requiredTextbox__badge__icon"
    matBadgePosition="above right"
    matTooltip="Textboxes"  
    matTooltipClass="'scorecard-icon-tooltip'"
    >
  
  </mat-icon>
  <span class="cdk-visually-hidden">Count of required Textbox(es) remaining to fill</span>
</div>

